import React, { useState } from "react";
import ChecklistCard from "../../ChecklistCard.js";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import MultiRepCard from "../../MultiRepCard.js";
import MustRefer from "../../MustRefer.js";
import ClauseCard from "../../ClauseCard.js";
import clauseData from "../../../data/Ontario/clauseData.js";
import clauseCardDesc from "../../../data/Ontario/clauseCardDescription.js";
import importantNotes from "../../../data/Ontario/importantNotes.js";
import ImportantNotes from "../../ImportantNotes.js";
import BackToTop from "../../BackToTop.js";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import ONClauseGenerator from "../../ONClauseGenerator.js";

export default function ResidentialPurchase() {
  const [SellerRep, setSellerRep] = useState("No");
  const [IsDisclosure, setIsDisclosure] = useState("No");
  const [APS, setAPS] = useState("100");
  const [ListingType, setListingType] = useState("MLS");
  const [BuyerRep, setBuyerRep] = useState("Client");

  const [BuyerDocs, setBuyerDocs] = useState([
    "RECO Info Guide Acknowledgement",
    "Buyer Representation Agreement with Schedule A (371)",
    "Related FINTRAC Documents",
  ]);

  const [DealDocs, setDealDocs] = useState([
    "Agreement of Purchase & Sale (100)",
    "Schedule B1 (if eXp holding deposit)",
    "Confirmation of Co-operation (320)",
    "Copy of Deposit & Receipt",
    "Full REALTOR® SOLD MLS Printout",
  ]);
  const FSBODocs = [
    "RECO Info Guide Acknowledgement",
    "RECO Self-Represented Disclosure Form",
    "Seller Related FINTRAC Documents",
  ];

  const theme = createTheme({
    palette: {
      primary: {
        main: "#506CAA",
        dark: "#506CAA",
      },
      text: {
        primary: "#31303F",
        secondary: "#506CAA",
      },
    },
  });

  const addDisclosure = (e) => {
    setIsDisclosure("Yes");
    if (
      DealDocs.includes("Registrant's Disclosure of Interest (160 or 161)") ===
      true
    ) {
      return;
    } else {
      setDealDocs([
        ...DealDocs,
        "Registrant's Disclosure of Interest (160 or 161)",
      ]);
    }
  };

  const removeDisclosure = (e) => {
    setIsDisclosure("No");
    setDealDocs(
      DealDocs.filter(
        (item) => item !== "Registrant's Disclosure of Interest (160 or 161)",
      ),
    );
  };

  const setExclusive = (e) => {
    setListingType(e.target.value);
    setDealDocs(
      DealDocs.filter((item) => item !== "Full REALTOR® SOLD MLS Printout"),
    );
  };

  const setMLS = (e) => {
    setListingType(e.target.value);
    if (DealDocs.includes("Full REALTOR® SOLD MLS Printout") === true) {
      return;
    } else {
      setDealDocs([...DealDocs, "Full REALTOR® SOLD MLS Printout"]);
    }
  };

  const handleSellerRep = (e) => {
    setSellerRep(e.target.value);
    if (e.target.value === "Yes") {
      setListingType("MLS");
      if (DealDocs.includes("Full REALTOR® SOLD MLS Printout") === true) {
        return;
      } else {
        setDealDocs([...DealDocs, "Full REALTOR® SOLD MLS Printout"]);
      }
    }
    if (e.target.value === "No") {
      setBuyerRep("Client");
      setBuyerDocs([
        "RECO Info Guide Acknowledgement",
        "Buyer Representation Agreement with Schedule A (371)",
        "Related FINTRAC Documents",
      ]);
    }
  };

  const handleBuyerRep = (e) => {
    setBuyerRep(e.target.value);
    if (e.target.value === "Client") {
      setBuyerDocs([
        "RECO Info Guide Acknowledgement",
        "Buyer Representation Agreement with Schedule A (371)",
        "Related FINTRAC Documents",
      ]);
    } else {
      setBuyerDocs([
        "RECO Info Guide Acknowledgement",
        "RECO Self-Represented Disclosure Form",
        "Related FINTRAC Documents",
      ]);
    }
  };

  const changeAPS = (e) => {
    setAPS(e.target.value);
    let newdata = DealDocs;
    newdata.shift();
    newdata.unshift("Agreement of Purchase & Sale (" + e.target.value + ")");
    setDealDocs(newdata);
  };

  return (
    <div className="checklists w-full flex flex-col items-center justify-center">
      <div className="flex flex-col w-full pl-4 ">
        <div className="flex flex-col items-left pb-2">
          <ThemeProvider theme={theme}>
            <FormControl sx={{ mt: 3, mb: 1, minWidth: 325, maxWidth: 110 }}>
              <InputLabel size="small" className="select-default-label">
                Property Type
              </InputLabel>
              <Select
                value={APS}
                name="Property Type"
                label="Property Type"
                onChange={changeAPS}
                size="small"
                sx={{ borderRadius: 20 }}
              >
                <MenuItem key={Math.random()} value="100">
                  Single Family
                </MenuItem>
                <MenuItem key={Math.random()} value="101">
                  Condo
                </MenuItem>
                <MenuItem key={Math.random()} value="110">
                  Mobile/Modular/Manufactured
                </MenuItem>
                <MenuItem key={Math.random()} value="111">
                  Parcel of Tied Land (POTL)
                </MenuItem>
                <MenuItem key={Math.random()} value="102">
                  Co-operative
                </MenuItem>
              </Select>
            </FormControl>
          </ThemeProvider>
          <div className="pr-5 pt-3">
            Do you also represent the Seller in this transaction?
          </div>
          <ThemeProvider theme={theme}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="No"
              >
                <FormControlLabel
                  value="Yes"
                  control={<Radio size="small" onClick={handleSellerRep} />}
                  label="Yes"
                />
                <FormControlLabel
                  value="No"
                  control={<Radio size="small" onClick={handleSellerRep} />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
          </ThemeProvider>
          {SellerRep === "Yes" ? (
            <>
              <div className="pr-5 pt-5">Buyer's Representation Choice?</div>
              <ThemeProvider theme={theme}>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    defaultValue="Client"
                    value={BuyerRep}
                  >
                    <FormControlLabel
                      value="Client"
                      control={<Radio size="small" onClick={handleBuyerRep} />}
                      label="Client"
                    />
                    <FormControlLabel
                      value="SRP"
                      control={<Radio size="small" onClick={handleBuyerRep} />}
                      label="Self-Represented Party"
                    />
                  </RadioGroup>
                </FormControl>
              </ThemeProvider>
            </>
          ) : (
            ""
          )}
          <div className="pr-5 pt-5">Type of Listing?</div>
          <ThemeProvider theme={theme}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="MLS"
                value={ListingType}
              >
                <FormControlLabel
                  value="MLS"
                  control={<Radio size="small" onClick={setMLS} />}
                  label="MLS"
                />
                <FormControlLabel
                  value="Exclusive"
                  control={<Radio size="small" onClick={setExclusive} />}
                  label="Exclusive"
                />
                {SellerRep !== "Yes" ? (
                  <>
                    <FormControlLabel
                      value="Mere"
                      control={<Radio size="small" onClick={setMLS} />}
                      label="Mere Posting"
                    />
                  </>
                ) : (
                  ""
                )}
                {SellerRep !== "Yes" ? (
                  <>
                    <FormControlLabel
                      value="FSBO"
                      control={<Radio size="small" onClick={setExclusive} />}
                      label="For Sale By Owner"
                    />
                  </>
                ) : (
                  ""
                )}
              </RadioGroup>
            </FormControl>
          </ThemeProvider>
          <div className="pr-5 pt-5">
            {SellerRep === "No"
              ? `Are you or close relatives purchasing this property?`
              : `Are you or any of your close relatives the Buyer or the Seller?`}
          </div>
          <ThemeProvider theme={theme}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="No"
              >
                <FormControlLabel
                  value="Yes"
                  control={<Radio size="small" onClick={addDisclosure} />}
                  label="Yes"
                />
                <FormControlLabel
                  value="No"
                  control={<Radio size="small" onClick={removeDisclosure} />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
          </ThemeProvider>
        </div>

        {ListingType === "Mere" ? (
          <>
            <div className="paragraph">
              <p>
                <strong>Important:</strong> Even though the listing brokerage is
                providing less services, they still have a representation
                agreement with the Seller. For the deposit, eXp should hold as
                the listing brokerage typically will not.
                <br />
                <br />
                <strong>FORM 320: </strong>Please ensure commission is clearly
                defined on FORM 320. In the commission section of FORM 320,
                check 4b-2 and put{" "}
                <em>
                  "[the commission amount] as per the remuneration clause in the
                  agreement"
                </em>
                . Make sure you include a Remuneration Clause in the Agreement
                of Purchase & Sale to cover the agreed upon commission. It is
                common for the listing brokerage to decline signing this form.
                Be sure to have the other parties sign.
                <br />
                <br />
                <strong>
                  Remuneration Clause:
                  <br />
                </strong>
                The Buyer directs the Seller and the Seller agrees to pay the
                Buyer's closing credit equal to _____ of the Purchase Price,
                plus applicable Harmonized Sales Tax (HST), to the Buyer's
                Brokerage, eXp Realty, at the closing of the transaction by the
                Seller's lawyer/representative. This payment is to be made to
                satisfy the Buyer's Buyer Representation Agreement (BRA) with
                eXp Realty, Brokerage.
              </p>
            </div>
          </>
        ) : (
          ""
        )}
        {ListingType === "FSBO" ? (
          <>
            <div className="paragraph">
              <p>
                <strong>Important:</strong> Commission cannot be paid directly
                by the Seller unless they agree to a Listing Agreement (271) or
                the APS contains a Remuneration Clause. If the Seller signs an
                agreement, this also creates Multiple Representation. If the
                Seller chooses to stay Self-Represented, commission can only be
                paid by the Buyer, unless you insert the Remuneration Clause
                into the agreement. For the deposit, eXp should hold since there
                isn't another brokerage involved in the transaction.
                <br />
                <br />
                <strong>FORM 320: </strong>For this scenario, you will use
                checkbox #3b only (if using Remuneration Clause). The presence
                of the Remuneration Clause in the agreement allows the
                commission to flow from the Seller to the Buyer, by way of a
                credit on closing. <br />
                <br />
                <strong>
                  Remuneration Clause (SRP Seller) - Have all parties initial
                  the clause in the agreement:
                  <br />
                </strong>
                The Buyer directs the Seller and the Seller agrees to pay the
                Buyer's closing credit equal to _____ of the Purchase Price,
                plus applicable Harmonized Sales Tax (HST), to the Buyer's
                Brokerage, eXp Realty, at the closing of the transaction by the
                Seller's lawyer/representative. This payment is to be made to
                satisfy the Buyer's Buyer Representation Agreement (BRA) with
                eXp Realty, Brokerage.
              </p>
            </div>
          </>
        ) : (
          ""
        )}
      </div>

      {SellerRep === "Yes" &&
      BuyerRep === "Client" &&
      IsDisclosure === "Yes" ? (
        <MustRefer IsMLS={ListingType} />
      ) : (
        <>
          {SellerRep === "Yes" && BuyerRep === "Client" ? <MultiRepCard /> : ""}
          {ListingType === "FSBO" ? (
            <ChecklistCard
              province={"ON"}
              CheckListData={BuyerDocs}
              CheckListData2={FSBODocs}
              CheckListData3={DealDocs}
              Header={"Purchase:"}
              Header2={"Buyer is a " + BuyerRep}
              Title1="Buyer Documents"
              Title2="Seller Documents"
              Title3="Deal Documents"
            />
          ) : (
            <ChecklistCard
              province={"ON"}
              CheckListData={BuyerDocs}
              CheckListData2={DealDocs}
              Header={"Purchase:"}
              Header2={"Buyer is a " + BuyerRep}
              Title1="Buyer Documents"
              Title2="Deal Documents"
            />
          )}
        </>
      )}

      {SellerRep === "Yes" &&
      BuyerRep === "Client" &&
      IsDisclosure === "Yes" ? (
        ""
      ) : ListingType === "Mere" || ListingType === "FSBO" ? (
        <ClauseCard
          ClauseCardDescription={clauseCardDesc.filter((item) =>
            item.category.includes("mere"),
          )}
          ClauseDataCommon={clauseData.filter(
            (item) => item.category.includes("mere") && item.isCommon === "yes",
          )}
          ClauseDataSituational={clauseData.filter(
            (item) => item.category.includes("mere") && item.isCommon === "no",
          )}
        />
      ) : (
        <ClauseCard
          ClauseCardDescription={clauseCardDesc.filter((item) =>
            item.category.includes("residential"),
          )}
          ClauseDataCommon={clauseData.filter(
            (item) =>
              (APS !== "101" &&
                item.category.includes("residential") &&
                item.isCommon === "yes") ||
              ((APS === "101" || APS === "102" || APS === "111") &&
                item.category.includes("condo") &&
                item.isCommon === "yes"),
          )}
          ClauseDataSituational={clauseData.filter(
            (item) =>
              item.category.includes("residential") && item.isCommon === "no",
          )}
          PurchaseType="Residential"
        />
      )}
      <ONClauseGenerator
        APS={APS}
        ListingType={ListingType}
        SellerRep={SellerRep}
        BuyerRep={BuyerRep}
        theme={theme}
        protectiveToneOptions={["Buyer Protective", "Seller Protective"]}
      />
      <div className="important-notes flex flex-col w-full justify-left pt-6">
        <strong>Important Notes:</strong>
        <div className="pb-3"></div>
        {ListingType === "FSBO" ? (
          <ImportantNotes
            Notes={importantNotes.filter(
              (notes) => notes.category.includes("fsbo") === true,
            )}
          />
        ) : (
          ""
        )}
        {IsDisclosure === "Yes" ? (
          <ImportantNotes
            Notes={importantNotes.filter(
              (notes) => notes.category.includes("disclosure") === true,
            )}
          />
        ) : (
          ""
        )}

        <ImportantNotes
          Notes={importantNotes.filter(
            (notes) => notes.category.includes("purchase") === true,
          )}
        />
      </div>
      <BackToTop />
    </div>
  );
}

/*
import ONClauseGenerator from "../../ONClauseGenerator.js";


<ONClauseGenerator
        APS={APS}
        ListingType={ListingType}
        SellerRep={SellerRep}
        BuyerRep={BuyerRep}
        theme={theme}
        protectiveToneOptions={[
          "Buyer Protective",
          "Seller Protective",
          "Landlord Protective",
          "Tenant Protective",
        ]}
      />
      */
